import * as React from 'react';

import { ListItem, ListItemIcon } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const styles = ({ spacing }: Theme) =>
    createStyles({
        iconCollapsed: { margin: 0, width: spacing.unit * 5 },
        iconExpanded: { mariginRight: spacing.unit * 2, width: spacing.unit * 5 },
        listItem: { paddingLeft: spacing.unit * 2, paddingRight: spacing.unit * 2 },
    });

interface IExpandableListItemProps extends WithStyles<typeof styles> {
    expanded: boolean;
    icon: React.ReactElement<SvgIconProps>;
    text: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

class ExpandableListItem extends React.Component<IExpandableListItemProps> {
    public render() {
        const { classes, expanded, icon, onClick, text } = this.props;
        const displayText = expanded ? text : null;
        const iconClass = expanded ? classes.iconExpanded : classes.iconCollapsed;
        return (
            <ListItem button className={classes.listItem} onClick={onClick}>
                <ListItemIcon className={iconClass}>{icon}</ListItemIcon>
                <span>{displayText}</span>
            </ListItem>
        );
    }
}

export default withStyles(styles)(ExpandableListItem);
export { IExpandableListItemProps };



// WEBPACK FOOTER //
// ./src/common/ExpandableListItem/ExpandableListItem.tsx